var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterUpdatedHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.17132 3.96501C6.17132 3.43932 6.15868 3.08887 6.68437 3.08887L17.1981 3.08887C17.7238 3.08887 18.0742 3.43932 18.0742 3.96501C18.0742 4.49069 17.7238 4.84115 17.1981 4.84115L6.68437 4.84115C6.15868 4.84115 6.17132 4.49069 6.17132 3.96501Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.550409 3.96501C0.550409 3.43932 0.900867 3.08887 1.42655 3.08887L3.17884 3.08887C3.70452 3.08887 3.84766 3.43932 3.84766 3.96501C3.84766 4.49069 3.70452 4.84115 3.17884 4.84115L1.42655 4.84115C0.900866 4.84115 0.550409 4.49069 0.550409 3.96501Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0846 10.1008C15.0846 9.57507 14.9201 9.22461 15.4458 9.22461L17.1981 9.22461C17.7238 9.22461 18.0742 9.57507 18.0742 10.1008C18.0742 10.6264 17.7238 10.9769 17.1981 10.9769L15.4458 10.9769C14.9201 10.9769 15.0846 10.6264 15.0846 10.1008Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.550813 10.1008C0.550813 9.57507 0.90127 9.22461 1.42696 9.22461L11.9407 9.22461C12.4663 9.22461 12.3351 9.57507 12.3351 10.1008C12.3351 10.6264 12.4663 10.9769 11.9407 10.9769L1.42696 10.9769C0.90127 10.9769 0.550813 10.6264 0.550813 10.1008Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6776 10.0987C10.6776 8.38925 11.9849 7.08203 13.6943 7.08203C15.4037 7.08203 16.7109 8.38925 16.7109 10.0987C16.7109 11.8081 15.4037 13.1153 13.6943 13.1153C11.9849 13.1153 10.6776 11.8081 10.6776 10.0987ZM14.6998 10.0987C14.6998 9.49535 14.2976 9.09313 13.6943 9.09313C13.091 9.09313 12.6887 9.49535 12.6887 10.0987C12.6887 10.702 13.091 11.1042 13.6943 11.1042C14.2976 11.1042 14.6998 10.702 14.6998 10.0987Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78498 3.96591C1.78498 2.18285 3.1485 0.819336 4.93155 0.819336C6.71461 0.819336 8.07812 2.18285 8.07812 3.96591C8.07812 5.74896 6.71461 7.11248 4.93155 7.11248C3.1485 7.11248 1.78498 5.74896 1.78498 3.96591ZM5.98041 3.96591C5.98041 3.33659 5.56087 2.91705 4.93155 2.91705C4.30224 2.91705 3.8827 3.33659 3.8827 3.96591C3.8827 4.59522 4.30224 5.01476 4.93155 5.01476C5.56087 5.01476 5.98041 4.59522 5.98041 3.96591Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterUpdatedHeader);
export default __webpack_public_path__ + "static/media/FilterUpdatedHeader.92d7a73f2098fd638360aee133836d53.svg";
export { ForwardRef as ReactComponent };